import React, { useState } from 'react';
import { Layout } from 'antd';
import { PageSpace, TabButton, TabContent } from '../styled';
import style from './index.scss';
import ResultTab from '../ResultTab';
import SummaryTab from '../SummaryTab';

const { Content } = Layout;

const Detection = () => {
  const [isResult, setIsResult] = useState(false);
  return (
    <Content>
      <PageSpace size={0} direction="vertical">
        <TabContent>
          <TabButton
            className={!isResult ? style.active : ''}
            onClick={() => setIsResult(!isResult)}>
            Summary
          </TabButton>
          <TabButton
            className={isResult ? style.active : ''}
            onClick={() => setIsResult(!isResult)}>
            Results
          </TabButton>
        </TabContent>
        {isResult ? <ResultTab /> : <SummaryTab from="Detection" />}
      </PageSpace>
    </Content>
  );
};

export default Detection;
